import { Action } from '@ngrx/store';

export const REQUEST_REHYDRATE = '[StorageSync][Request] Load from storage';
export const RESPONSE_REHYDRATED = '[StorageSync][Response] State restored';
export const REQUEST_SAVE_TO_STORAGE = '[StorageSync][Request] Save state to storage';
export const RESPONSE_SAVE_TO_STORAGE = '[StorageSync][Response] State saved to storage';

/**
 * Action to trigger an app rehydrate from storage
 */
export class RequestRehydrate implements Action {
  readonly type = REQUEST_REHYDRATE;
}

export class RequestSaveToStorage implements Action {
  readonly type = REQUEST_SAVE_TO_STORAGE;
  constructor(public payload: any) {}
}

export class ResponseSaveToStorage implements Action {
  readonly type = RESPONSE_SAVE_TO_STORAGE;
}

/**
 * An action to indicate the state has been restored
 */
export class ResponseRehydrated implements Action {
  readonly type = RESPONSE_REHYDRATED;

  /**
   * Build a new action.
   *
   * @param payload The state restored from storage
   */
  constructor(public payload: Object) {}
}
